export const normalizeExternalUrl = (value?: string): string => {
  const normalized = (value ?? '').trim().replace(/^(https?)=\/+/i, '$1://');

  try {
    const url = new URL(normalized);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
  } catch {
    return '';
  }
};
